import { apiSlice } from '../../api/apiSlice';

export const classApis = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createClass: builder.mutation({
      query: (name) => ({
        url: 'Class',
        method: 'POST',
        body: {name}
      })
    }),
    getClassesForList: builder.mutation({
      query: (options) => ({
        url: 'Class/MyClasses',
        method: 'GET',
        params: {...options}
      })
    }),
    hideClass: builder.mutation({
      query: (id) => ({
        url: `Class/${id}`,
        method: 'DELETE'
      })
    }),
    unhideClass: builder.mutation({
      query: (id) => ({
        url: `Class/${id}/Restore`,
        method: 'PUT'
      })
    }),
    getAllCoTeachers: builder.mutation({
      query: (id) => ({
        url: `Class/${id}/CoTeachers`,
        method: 'GET'
      })
    }),
    deleteCoTeacher: builder.mutation({
      query: (options) => ({
        url: `Class/${options.id}/CoTeachers/${options.teacherId}`,
        method: 'DELETE'
      })
    }),
    addCoTeacher: builder.mutation({
      query: (options) => ({
        url: `Class/${options.id}/CoTeachers`,
        method: 'POST',
        credentials: 'include',
        body: options.coTeachers
      })
    }),
    getTeacherClasses: builder.mutation({
      query: (options) => ({
        url: `class/school/${options.schoolId}/teacher/${options.teacherId}`,
        method: 'GET'
      })
    }),
    getClassStudents: builder.mutation({
      query: (options) => ({
        url: `class/${options.id}/students`,
        method: 'GET',
        credentials: 'include',
        params:{schoolId : options.schoolId}
      })
    }),
    duplicateClass: builder.mutation({
      query: (duplicateClassId) => ({
        url: `class/Duplicate/${duplicateClassId}`,
        method: 'POST',
        credentials: 'include',
      })
    }),
    getClassManagementStudents: builder.mutation({
      query: (options) => ({
        url: `class/${options.id}/studentManagement?includeDeleted=${options.includeDeleted}`,
        method: 'GET'
      })
    }),
    getClassEditStatus: builder.mutation({
      query: (id) => ({
        url: `class/${id}/EditStatus`,
        method: 'GET'
      })
    }),
    getStudentSessions: builder.mutation({
      query: (options) => ({
        url: `class/${options.classId}/StudentSessions?courseId=${options.courseId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getMathSkillStudents: builder.mutation({
      query: (options) => ({
        url: `class/${options.classId}/MathSkillStudents?courseId=${options.courseId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getMathSkillReport: builder.mutation({
      query: (options) => ({
        url: `CourseReport/${options.courseId}/Student/${options.studentId}/SkillReport`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    rename: builder.mutation({
      query: (options) => ({
        url: `Class/${options.id}/Rename`,
        method: 'PUT',
        body: {name:options.name}
      })
    }),
    moveStudents: builder.mutation({
      query: (options) => ({
        url: `Class/${options.id}/MoveStudents/toClass/${options.toClassId}`,
        method: 'PUT',
        credentials: 'include',
        body: options.studentIds
      })
    }),
    removeStudents: builder.mutation({
      query: (options) => ({
        url: `Class/${options.id}/Students`,
        method: 'DELETE',
        credentials: 'include',
        body: options.studentIds
      })
    }),
    transferOwnerShip: builder.mutation({
      query: (options) => ({
        url: `Class/${options.id}/TransferOwnership/toTeacher/${options.teacherId}`,
        method: 'PUT',
        params: options
      })
    }),
    getCalendarURL: builder.mutation({
      query: (id) => ({
        url: `Class/${id}/calendarURL`,
        method: 'GET',
        credentials: 'include',
      })
    }),
    saveCalendarURL: builder.mutation({
      query: (options) => ({
        url: `Class/${options.id}/calendarURL`,
        method: 'PUT',
        params : options
      })
    }),
    addStudent: builder.mutation({
      query: (options) => ({
        url: `Class/${options.id}/AddStudents`,
        method: 'POST',
        body: options.studentIds
      })
    }),
    getAccessRights: builder.mutation({
      query: (options) => ({
        url: `Class/${options.id}/AccessRights`,
        method: 'GET',
        params:{courseId:options.courseId},
        credentials: 'include',
      })
    }),
    viewSessions: builder.query({
      query: (options) => ({
        url: `Class/${options.classId}/ViewSessions`,
        method: 'GET',
        params:{courseId: options.courseId, studentId: options.studentId}
      })
    }),
  })
});

export const {
  useCreateClassMutation,
  useGetClassesForListMutation,
  useHideClassMutation,
  useUnhideClassMutation,
  useGetAllCoTeachersMutation,
  useDeleteCoTeacherMutation,
  useAddCoTeacherMutation,
  useGetTeacherClassesMutation,
  useGetClassStudentsMutation,
  useDuplicateClassMutation,
  useGetClassManagementStudentsMutation,
  useGetClassEditStatusMutation,
  useGetStudentSessionsMutation,
  useGetMathSkillStudentsMutation,
  useGetMathSkillReportMutation,
  useRenameMutation,
  useMoveStudentsMutation,
  useRemoveStudentsMutation,
  useTransferOwnerShipMutation,
  useGetCalendarURLMutation,
  useSaveCalendarURLMutation,
  useAddStudentMutation,
  useGetAccessRightsMutation,
  useViewSessionsQuery
} = classApis;